import React, {useEffect, createRef} from 'react'

export default Wrapped => {

    const handleClick = event => {
        const {
            currentTarget
        } = event


        const resource_position = currentTarget.getAttribute("data-position")
        const resource_content = currentTarget.getAttribute("data-content")
        const resource_type = currentTarget.getAttribute("data-type")
        const product_sku = currentTarget.getAttribute("data-sku")
       
        window?.GeekoSensors?.Track("ELClick", {
            resource_position,
            resource_type,
            resource_content,
            product_sku,
            pdetai_product_id: window.pdetai_product_id
        })

    }


    return props => {
        const dom = createRef()
        useEffect(() => {
            // window?.elObserver?.observe(dom.current)

            dom?.current?.addEventListener?.('click', handleClick)

            return () => {
                // window?.elObserver?.unobserve(dom.current)
            }
        }, [])
        return <Wrapped innerRef={dom} {...props}/>
    }
}